var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPlayButton = function SvgPlayButton(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    width: 98,
    height: 86,
    x: -272,
    y: -340,
    overflow: "visible",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 -86 98 86"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d77013",
    d: "M98 0H0v-86h98z",
    "data-original": "#d77013"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.766 0 0 10.766 0 24s10.766 24 24 24 24-10.766 24-24S37.234 0 24 0zm0 43.473C13.263 43.473 4.528 34.736 4.528 24S13.263 4.529 24 4.529c10.736 0 19.472 8.734 19.472 19.471S34.736 43.473 24 43.473z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.201 22.086-16.359-10.35a2.263 2.263 0 0 0-3.474 1.914v20.701a2.264 2.264 0 0 0 3.474 1.911l16.359-10.35a2.265 2.265 0 0 0 0-3.826zm-15.305 8.152V17.762L29.756 24z",
    fill: "d77013"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playButton.04705a64.svg";
export { ForwardRef as ReactComponent };